import { SelectAthleteDialog } from "./SelectAthleteDialog";
import { EntryTypeDialog } from "./EntryTypeDialog";
import { SelectDivisionDialog } from "./SelectDivisionDialog";
import { AthleteSelector } from "./AthleteSelector";

export const DIALOGS = {
    "entry-type": EntryTypeDialog,
    "individual": SelectAthleteDialog,
    "team": SelectDivisionDialog,
};

export const EntrySelector = ({ options, athletes, ...rest }) => {
    const individualDivisions = options.filter(option => !option.isTeams);
    const teamDivisions = options.filter(option => option.isTeams);

    const dialog = individualDivisions.length && teamDivisions.length ? "entry-type" : individualDivisions.length ? "individual" : "team";
    const dialogId = `${dialog}-selector-dialog-title`;
    const Dialog = DIALOGS[dialog];

    return (
        <AthleteSelector
            athletes={athletes}
            options={options}
            teamDivisions={teamDivisions}
            dialogId={dialogId}
            Dialog={Dialog}
            {...rest}
        />
    );
};
